/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { adminChatAnalysisGetSettings } from "../funcs/adminChatAnalysisGetSettings.js";
import { adminChatAnalysisTriggerAnalysis } from "../funcs/adminChatAnalysisTriggerAnalysis.js";
import { adminChatAnalysisUpsertBusinessMemorySettings } from "../funcs/adminChatAnalysisUpsertBusinessMemorySettings.js";
import { adminChatAnalysisUpsertWorkUnitsSettings } from "../funcs/adminChatAnalysisUpsertWorkUnitsSettings.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ChatAnalysisSettings } from "../models/components/chatanalysissettings.js";
import { TriggerAnalysisResponseBody } from "../models/components/triggeranalysisresponsebody.js";
import {
  GetChatAnalysisSettingsRequest,
  GetChatAnalysisSettingsSecurity,
} from "../models/operations/getchatanalysissettings.js";
import {
  TriggerChatAnalysisRequest,
  TriggerChatAnalysisSecurity,
} from "../models/operations/triggerchatanalysis.js";
import {
  UpsertBusinessMemoryAnalysisSettingsRequest,
  UpsertBusinessMemoryAnalysisSettingsSecurity,
} from "../models/operations/upsertbusinessmemoryanalysissettings.js";
import {
  UpsertChatAnalysisSettingsRequest,
  UpsertChatAnalysisSettingsSecurity,
} from "../models/operations/upsertchatanalysissettings.js";
import { unwrapAsync } from "../types/fp.js";

export class AdminChatAnalysis extends ClientSDK {
  /**
   * getSettings adminChatAnalysis
   *
   * @remarks
   * Get the named organization's chat analysis settings. Requires platform admin.
   */
  async getSettings(
    request: GetChatAnalysisSettingsRequest,
    security?: GetChatAnalysisSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ChatAnalysisSettings> {
    return unwrapAsync(adminChatAnalysisGetSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * triggerAnalysis adminChatAnalysis
   *
   * @remarks
   * Wake the chat analysis coordinator for every project in the named organization, instead of waiting for the periodic sweep. Requires platform admin.
   */
  async triggerAnalysis(
    request: TriggerChatAnalysisRequest,
    security?: TriggerChatAnalysisSecurity | undefined,
    options?: RequestOptions,
  ): Promise<TriggerAnalysisResponseBody> {
    return unwrapAsync(adminChatAnalysisTriggerAnalysis(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertBusinessMemorySettings adminChatAnalysis
   *
   * @remarks
   * Create or replace the named organization's business-memory extraction settings. Requires platform admin.
   */
  async upsertBusinessMemorySettings(
    request: UpsertBusinessMemoryAnalysisSettingsRequest,
    security?: UpsertBusinessMemoryAnalysisSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ChatAnalysisSettings> {
    return unwrapAsync(adminChatAnalysisUpsertBusinessMemorySettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertWorkUnitsSettings adminChatAnalysis
   *
   * @remarks
   * Create or replace the named organization's chat analysis settings. Requires platform admin.
   */
  async upsertWorkUnitsSettings(
    request: UpsertChatAnalysisSettingsRequest,
    security?: UpsertChatAnalysisSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ChatAnalysisSettings> {
    return unwrapAsync(adminChatAnalysisUpsertWorkUnitsSettings(
      this,
      request,
      security,
      options,
    ));
  }
}
